/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { AxiosPromise, AxiosResponse, CancelToken } from 'axios';
import { injectable } from '@servicetitan/react-ioc';
import { MockResponseConfig } from 'utils';
import {
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    IOnboardingWizardCompanyProfileApi,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    CompanyProfileModel,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    CompanyProfileResponseModel,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    CompanyProfileRequestModel,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    CompanyAddressVerificationModel,
    // @ts-ignore: noUnusedLocals on imported objects in __mocks__
    CompanyAddressModel
} from '../onboarding-wizard-company-profile.api';

@injectable()
export class OnboardingWizardCompanyProfileApiMock implements IOnboardingWizardCompanyProfileApi {
    private handleCall<T>(config: MockResponseConfig<T> | null | undefined): AxiosPromise<T> {
        if (!config) {
            throw new Error('Mock not configured');
        }
        if (typeof config.responseCount === 'number') {
            if (config.responseCount === 0) {
                throw new Error('Mock exceeded allowed response count');
            }
            config.responseCount = config.responseCount - 1;
        }
        if (config.error && config.response) {
            throw new Error('Mock has both response and error configured');
        }
        if (config.error) {
            return Promise.reject(config.error);
        }
        if (config.response) {
            return Promise.resolve(config.response as AxiosResponse<T>);
        }
        throw new Error('Mock configuration missing reponse');
    }

    private companyProfileGetConfig: MockResponseConfig<CompanyProfileResponseModel | undefined> | null | undefined;
    companyProfileGetConfigure(config: MockResponseConfig<CompanyProfileResponseModel | undefined> | null): void {
        this.companyProfileGetConfig = config;
    }
    companyProfileGet(_0?: CancelToken): AxiosPromise<CompanyProfileResponseModel | undefined> {
        return this.handleCall(this.companyProfileGetConfig);
    }

    private companyProfileUpdateWithLogoConfig: MockResponseConfig<string | undefined> | null | undefined;
    companyProfileUpdateWithLogoConfigure(config: MockResponseConfig<string | undefined> | null): void {
        this.companyProfileUpdateWithLogoConfig = config;
    }
    companyProfileUpdateWithLogo(_0: Blob, _1?: CancelToken): AxiosPromise<string | undefined> {
        return this.handleCall(this.companyProfileUpdateWithLogoConfig);
    }

    private companyProfileUpdateConfig: MockResponseConfig<string | undefined> | null | undefined;
    companyProfileUpdateConfigure(config: MockResponseConfig<string | undefined> | null): void {
        this.companyProfileUpdateConfig = config;
    }
    companyProfileUpdate(_0: CompanyProfileRequestModel, _1?: CancelToken): AxiosPromise<string | undefined> {
        return this.handleCall(this.companyProfileUpdateConfig);
    }

    private verifyAddressConfig: MockResponseConfig<CompanyAddressVerificationModel | undefined> | null | undefined;
    verifyAddressConfigure(config: MockResponseConfig<CompanyAddressVerificationModel | undefined> | null): void {
        this.verifyAddressConfig = config;
    }
    verifyAddress(_0: CompanyAddressModel, _1?: CancelToken): AxiosPromise<CompanyAddressVerificationModel | undefined> {
        return this.handleCall(this.verifyAddressConfig);
    }

    private addressVerificationRequiredConfig: MockResponseConfig<boolean> | null | undefined;
    addressVerificationRequiredConfigure(config: MockResponseConfig<boolean> | null): void {
        this.addressVerificationRequiredConfig = config;
    }
    addressVerificationRequired(_0?: CancelToken): AxiosPromise<boolean> {
        return this.handleCall(this.addressVerificationRequiredConfig);
    }
}
